import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dialog-close-button',
    templateUrl: './dialog-close-button.component.html',
    styleUrls: ['./dialog-close-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DialogCloseButtonComponent {

  constructor() { }

}
